import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckListParametersComponent } from './check-list-parameters/check-list-parameters.component';
import { SharedModule } from '@app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragulaModule } from 'ng2-dragula';
import { TooltipModule, TabsModule, BsDropdownModule, PaginationModule } from 'ngx-bootstrap';
import { FlowModule } from '@app/flow';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    DragulaModule,
    FlowModule,
    PaginationModule,
    TooltipModule.forRoot(),
    TabsModule.forRoot(),
    BsDropdownModule.forRoot(),
  ],
  exports: [
    SharedModule,
    FlowModule,
    ReactiveFormsModule,
    FormsModule,
    DragulaModule,
    TooltipModule,
    TabsModule,
    BsDropdownModule,
    CheckListParametersComponent
  ],
  declarations: [CheckListParametersComponent],
  entryComponents: [CheckListParametersComponent]
})
export class SharedAdministrationModule { }



// WEBPACK FOOTER //
// ./src/app/administration/shared-administration/shared-administration.module.ts